import React from "react";

export default function SurgeryIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0001 1.33351V2.00018C14.0001 2.66685 12.6667 2.66685 12.6667 3.33351C12.6667 4.00018 14.0001 4.00018 14.0001 4.66685C14.0001 5.33351 12.6667 5.33351 12.6667 6.00018C12.6667 6.66685 14.0001 6.66685 14.0001 7.33351C14.0001 8.00018 12.6667 8.00018 12.6667 8.66685M4.00006 4.00018H3.9934M12.0001 12.0002H11.9934M4.00006 7.77351V14.6668C3.29282 14.6668 2.61454 14.3859 2.11445 13.8858C1.61435 13.3857 1.3334 12.7074 1.3334 12.0002V4.00018M2.1134 5.88685C1.86564 5.63909 1.6691 5.34495 1.53501 5.02124C1.40093 4.69752 1.33191 4.35057 1.33191 4.00018C1.33191 3.64979 1.40093 3.30284 1.53501 2.97912C1.6691 2.65541 1.86564 2.36127 2.1134 2.11351C2.36116 1.86575 2.65529 1.66922 2.97901 1.53513C3.30272 1.40104 3.64968 1.33203 4.00006 1.33203C4.35045 1.33203 4.69741 1.40104 5.02112 1.53513C5.34484 1.66922 5.63897 1.86575 5.88673 2.11351L13.8867 10.1135C14.3871 10.6139 14.6682 11.2925 14.6682 12.0002C14.6682 12.3506 14.5992 12.6975 14.4651 13.0212C14.331 13.345 14.1345 13.6391 13.8867 13.8868C13.639 14.1346 13.3448 14.3311 13.0211 14.4652C12.6974 14.5993 12.3504 14.6683 12.0001 14.6683C11.2924 14.6683 10.6138 14.3872 10.1134 13.8868L2.1134 5.88685Z"
        stroke="#14B8A6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
